
import { useParams } from "react-router-dom";
import { useNotificacionXBodega } from "../../../hooks";
import { DisenioBodega } from "../../layout";
import { BuscadorSoloValor, CargandoMedio } from "../../components";
import { ModalFormUno } from "../../components/components/ModalFormUno";
import { useModalesStore, useNotificacionesStore } from "../../../store";
import { FormAprobarTraslados, TablaNotificaciones } from "../../components/productos/inventario";




export const NotificacionTraslados = () => {

    const { id } = useParams();
    const { notificacionXBodegaQuery, page, termino, chagePage, chageTermino } = useNotificacionXBodega(id);
    const { activeNotificacion } = useNotificacionesStore();
    const { changeEstadoModalUno } = useModalesStore(); 



    return (

        <DisenioBodega titulo="Notificaciones Traslados" add={false}>
            {(notificacionXBodegaQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Notificaciones..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} 
                    titulo='Buscar producto.' place='Buscar x nombre'
                />
                <TablaNotificaciones data={notificacionXBodegaQuery?.data || []} page={page} chagePage={chagePage} />
                </>
            }


            {(activeNotificacion) && 
            <ModalFormUno titulo={`${activeNotificacion?.estado} Traslado`} valor={activeNotificacion} onClose={() => changeEstadoModalUno(false)}>
                <FormAprobarTraslados />
            </ModalFormUno>
            }
        </DisenioBodega>

    )
}
